<div class="box">
    <div class="itax-body">
        <div class="container position-relative w-100 h-100 body">
            <div class="row d-flex justify-content-center">
                <div class="col-12">
                    <h2 class="h2 w-100 text-center mb-30px title">ทำไมต้องมางาน iTAX {{year}} เทศกาลลดหย่อนภาษีประจำปี</h2>
                    <div class="row">
                        <div class="col d-grid">
                            <div class="d-flex justify-content-center pb-15px">
                                <img src="/assets/images/landing-page/man.png" width="100" height="100" alt="person" title="person">
                            </div>
                            <div class="p1 d-flex justify-content-center text-center text">มีผู้เชี่ยวชาญช่วยจัดการภาษี</div>
                        </div>
                        <div class="col d-grid">
                            <div class="d-flex justify-content-center pb-15px">
                                <img src="/assets/images/landing-page/img-checklist.png" width="100" height="100" alt="checklist" title="checklist">
                            </div>
                            <div class="p1 d-flex justify-content-center text-center text">ได้แผนลดหย่อนภาษีทันที</div>
                        </div>
                        <div class="col d-grid">
                            <div class="d-flex justify-content-center pb-15px">
                                <img src="/assets/images/landing-page/img-shoppingcart.png" width="100" height="100" alt="shopping" title="shopping">
                            </div>
                            <div class="p1 d-flex justify-content-center text-center text">มีตัวเลือกลดหย่อนภาษีครบในงานเดียว</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
